"use strict"

import { getCartCount } from "../services/user";

export function init() {
    const SELECTOR = '.js-cart-status';
    const INNER = '.cart-number'
    const element = document.querySelector(SELECTOR);

    if (element === null) {
        return false;
    }

    let cartCount = getCartCount();

    if (cartCount) {
        element.querySelector(INNER).innerText = cartCount;
        document.body.classList.add('items-in-cart');
    } else {
        document.body.classList.remove('items-in-cart');
    }

}